import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=1aead0d1&scoped=true"
import script from "./newIndex.vue?vue&type=script&lang=js"
export * from "./newIndex.vue?vue&type=script&lang=js"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=1aead0d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aead0d1",
  null
  
)

export default component.exports